import React from 'react'

const Divider = ({color, hp, marge}) => {
  return (
        <div style={{width: '100%', height: hp, borderRadius: 30, margin: marge, backgroundColor: color}}></div>
      )
}

export default Divider